import React from 'react';
import './About.css'
import Layout from '../../components/Layout/Layout';
import reactIcon from '../../imgSource/skills/react-original.svg';
import javascriptIcon from '../../imgSource/skills/javascript-original.svg';
import pythonIcon from '../../imgSource/skills/python-original.svg';
import htmlIcon from '../../imgSource/skills/html5-original.svg';
import cssIcon from '../../imgSource/skills/css3-original.svg';
import nodeIcon from '../../imgSource/skills/nodejs-original.svg';
import mongodbIcon from '../../imgSource/skills/mongodb-original.svg';
import mysqlIcon from '../../imgSource/skills/mysql-original.svg';
import postgresIcon from '../../imgSource/skills/postgresql-original.svg';
import expressIcon from '../../imgSource/skills/express-original.svg';
import djangoIcon from '../../imgSource/skills/django-plain.svg';
import mongooseIcon from '../../imgSource/skills/mongoose-original.svg';
import azureIcon from '../../imgSource/skills/azure-original.svg';

const skills = [
  { name: 'React', icon: reactIcon },
  { name: 'Javascript', icon: javascriptIcon },
  { name: 'Python', icon: pythonIcon },
  { name: 'HTML', icon: htmlIcon },
  { name: 'CSS', icon: cssIcon },
  { name: 'NodeJS', icon: nodeIcon },
  { name: 'Mongo DB', icon: mongodbIcon },
  { name: 'MySQL', icon: mysqlIcon },
  { name: 'Postgre', icon: postgresIcon },
  { name: 'Express', icon: expressIcon },
  { name: 'Django', icon: djangoIcon },
  { name: 'Mongoose', icon: mongooseIcon },
  { name: 'Azure', icon: azureIcon },
];

export default function About() {

  return (
    <Layout>
      <div className='about'>

        <h1 className='title'>
          <span className='crimson'>A</span>bout
        </h1>
        <p className='intro'>
          I work across the full stack, from the front end people interact with to the APIs and databases behind it, and increasingly the cloud infrastructure that runs it all. I like understanding how every layer fits together, because that's what makes systems reliable, scalable, and easy to change.
        </p>
        <div className='skillcards'>
          {skills.map((skill) => (
            <div className='card' key={skill.name}>
              <img src={skill.icon} alt={skill.name} className='skillIcon' />
              <p className='cardName'>
                {skill.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
